/** This is the single select form component type  */

export { default as MultiSelectField } from './multi-select-field';
